// src/utils/whatsapp.ts

/**
 * Costruisce l'URL wa.me per aprire una chat WhatsApp con il numero di un cliente.
 * wa.me accetta solo cifre con prefisso internazionale (niente +, spazi o trattini).
 * Ritorna null se il numero non è valido.
 */
export const getWhatsAppUrl = (phone?: string | null): string | null => {
    if (!phone) return null;
    const digits = String(phone).replace(/\D/g, '');
    if (!digits) return null;
    return `https://wa.me/${digits}`;
};
